import { render, staticRenderFns } from "./CellRegenerationRateCard.vue?vue&type=template&id=4bb99c17"
import script from "./CellRegenerationRateCard.vue?vue&type=script&lang=ts"
export * from "./CellRegenerationRateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports